import { render, staticRenderFns } from "./FormElementSentenceStructure.vue?vue&type=template&id=29245d79&scoped=true&"
import script from "./FormElementSentenceStructure.vue?vue&type=script&lang=js&"
export * from "./FormElementSentenceStructure.vue?vue&type=script&lang=js&"
import style0 from "./FormElementSentenceStructure.vue?vue&type=style&index=0&id=29245d79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29245d79",
  null
  
)

export default component.exports